export function DevinWindsurfLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 48 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Devin | Windsurf"
    >
      {/* Devin hexagon cluster */}
      <g fill="currentColor">
        {/* Outer hexagon */}
        <path d="M6 2.5L10 4.75V9.25L6 11.5L2 9.25V4.75L6 2.5Z" opacity="0.9" />
        {/* Inner hexagons */}
        <path d="M6 5.5L7.5 6.25V7.75L6 8.5L4.5 7.75V6.25L6 5.5Z" opacity="0.6" />
        <path d="M6 8.5L7.5 9.25V10.75L6 11.5L4.5 10.75V9.25L6 8.5Z" opacity="0.6" />
        <path d="M7.5 6.25L9 7V8.5L7.5 9.25L6 8.5V7L7.5 6.25Z" opacity="0.6" />
        <path d="M4.5 6.25L6 7V8.5L4.5 9.25L3 8.5V7L4.5 6.25Z" opacity="0.6" />
        <path d="M6 3.5L7.5 4.25V5.75L6 6.5L4.5 5.75V4.25L6 3.5Z" opacity="0.6" />
        <path d="M7.5 4.25L9 5V6.5L7.5 7.25L6 6.5V5L7.5 4.25Z" opacity="0.6" />
        <path d="M4.5 4.25L6 5V6.5L4.5 7.25L3 6.5V5L4.5 4.25Z" opacity="0.6" />
      </g>
      {/* Windsurf W */}
      <path
        d="M17 6C18 6 19 8 20 10C21 12 22 14 23 14C24 14 25 12 26 10C27 8 28 6 29 6C30 6 31 8 32 10C33 12 34 14 35 14C36 14 37 12 38 10C39 8 40 6 41 6"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
